import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";
import { useSettingsStore } from "@/store/settings/settingsStore";

const settingDebug = () => {
    const debugMode = useSettingsStore().settings.useDebug ? "enabled" : "disabled";
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:debug:${debugMode}`, 
        category: settings.categoryName 
    });
};

export default settingDebug;